import React, { Component } from "react";
import PropTypes from "prop-types";

class CampaignAutoStop extends Component {
  static propTypes = {
    campaign: PropTypes.object.isRequired,
    handleSave: PropTypes.func.isRequired,
    handleSaveAutoStop: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      autoStop: this.props.campaign.auto_stop
    };
  }

  handleChange(e) {
    let auto_stop = e.target.checked;
    this.setState({ autoStop: auto_stop });
    this.props.handleSaveAutoStop(this.props.campaign.id, {
      auto_stop: auto_stop
    });
  }

  render() {
    return (
      <div className="form-group auto-pause">
        <label className="">Automatically Stop Workflow on Communication</label>
        <input
          type="checkbox"
          className="auto_stop fr m-l-5"
          labelClassName=""
          wrapperClassName=""
          value="true"
          checked={this.state.autoStop}
          name="auto_stop"
          onChange={this.handleChange.bind(this)}
        />
      </div>
    );
  }
}

export default CampaignAutoStop;
